export default __webpack_public_path__ + "static/media/firefox.c2cc54eb.svg";